import axiosInstance from "@/api/axios-instance";
import { UserBundleOption } from "@/pages/audit/types/unmapped-sessions";

export interface UserBundlesForMappingResponse {
  bundles: UserBundleOption[];
}

export async function getUserBundlesForMapping(params: {
  phone?: string;
  email?: string;
}): Promise<UserBundlesForMappingResponse> {
  const response = await axiosInstance.get("/audit/user-bundles-for-mapping", {
    params,
  });
  return response.data;
}
